import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";

function Banner({ data }) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="SAP">
                <h1>SAP Consultants For Business Transformation</h1>
              </div>
              <div className="banner_content_txt listing_flex">
                <p>
                  TekRevol helps businesses enhance their reporting and digital
                  transformation roadmaps. TekRevol's SAP consultants assist
                  clients across diverse industries with data management and
                  analytics, application management, and cloud solutions,
                  enhancing their reporting and digital transformation roadmaps.
                </p>
                <ul>
                  <li>Data Management & Analytics</li>
                  <li>Cloud Solutions</li>
                  <li>Application Management</li>
                  <li>Business Transformation</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ms-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
